import { useQuery } from '@apollo/client';
import { Button, Heading, Input, Paragraph, Stack, useNotifications } from '@sixfold/common-ui';
import { notNil } from '@sixfold/typed-primitives';
import copy from 'copy-to-clipboard';
import { useState } from 'react';

import { GenerateIntercomTokenUrlQuery, GenerateIntercomTokenUrlQueryVariables } from '../../lib/graphql';
import { useDebounce } from '../../lib/util/debounce';
import { getGenerateIntercomTokenQuery } from '../graphql';

export const IntercomContainer = () => {
  const { success } = useNotifications();
  const [websiteUrl, setWebsiteUrl] = useState<string | null>(null);

  const debouncedWebsiteUrl = useDebounce(websiteUrl, 500);

  const isUrlEntered = debouncedWebsiteUrl !== null && debouncedWebsiteUrl.length > 0;

  const { data } = useQuery<GenerateIntercomTokenUrlQuery, GenerateIntercomTokenUrlQueryVariables>(
    getGenerateIntercomTokenQuery,
    {
      skip: !isUrlEntered,
      variables: {
        baseUrl: debouncedWebsiteUrl ?? '',
      },
    },
  );

  const handleCopy = async () => {
    const copied = await copy(data?.intercomTokenUrl ?? '');
    if (copied) {
      success({ title: 'Success', message: 'URL copied to clipboard' });
    }
  };

  return (
    <Stack gap="small">
      <Heading size="large" type="title">
        Generate URL to allow editing of Intercom tours.
      </Heading>
      <Paragraph>
        Here you can generate a URL that will allow loading of the intercom tools package. This package is needed to
        create product tours on the intercom.com website. The generated token is valid for 24 hours.
      </Paragraph>

      <Input
        label="Base URL"
        labelPosition="hidden"
        name="input"
        placeholder="Enter the URL to add token to"
        onChange={({ value }) => {
          setWebsiteUrl(value);
        }}
      />
      {notNil(data?.intercomTokenUrl) && data?.intercomTokenUrl !== '' && (
        <>
          <Paragraph className="intercom_token">{data?.intercomTokenUrl}</Paragraph>

          <Button kind="primary" onClick={() => void handleCopy()}>
            Copy URL with token
          </Button>
        </>
      )}
    </Stack>
  );
};
